import React from 'react';
import { MessageSquareIcon, ClockIcon, XIcon, CheckIcon } from 'lucide-react';
const ProblemStatement = () => {
  return <section className="py-16 bg-white" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-271">
          <h2 className="text-3xl md:text-4xl font-bold font-display text-charcoal" data-id="element-272">
            Stop Drowning in Customer Messages
          </h2>
          <p className="mt-4 text-lg text-sage" data-id="element-273">
            Restaurant owners spend an average of 12+ hours weekly managing
            customer communications
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-274">
          <div className="bg-cream rounded-lg p-6 shadow-lg" data-id="element-275">
            <div className="flex items-center mb-4" data-id="element-276">
              <div className="w-10 h-10 rounded-full bg-burgundy/10 flex items-center justify-center text-burgundy mr-4" data-id="element-277">
                <XIcon size={20} data-id="element-278" />
              </div>
              <h3 className="text-xl font-semibold text-charcoal" data-id="element-279">
                Without ChefChat
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-280">
              <li className="flex items-start" data-id="element-281">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-burgundy/10 flex items-center justify-center text-burgundy mr-3 mt-0.5" data-id="element-282">
                  <XIcon size={14} data-id="element-283" />
                </div>
                <p data-id="element-284">Missed reservation requests during busy service hours</p>
              </li>
              <li className="flex items-start" data-id="element-285">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-burgundy/10 flex items-center justify-center text-burgundy mr-3 mt-0.5" data-id="element-286">
                  <XIcon size={14} data-id="element-287" />
                </div>
                <p data-id="element-288">
                  Hours spent responding to the same questions about hours,
                  menu, and location
                </p>
              </li>
              <li className="flex items-start" data-id="element-289">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-burgundy/10 flex items-center justify-center text-burgundy mr-3 mt-0.5" data-id="element-290">
                  <XIcon size={14} data-id="element-291" />
                </div>
                <p data-id="element-292">
                  Negative reviews from customers who never received a response
                </p>
              </li>
              <li className="flex items-start" data-id="element-293">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-burgundy/10 flex items-center justify-center text-burgundy mr-3 mt-0.5" data-id="element-294">
                  <XIcon size={14} data-id="element-295" />
                </div>
                <p data-id="element-296">
                  Constant phone interruptions during critical kitchen
                  operations
                </p>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-burgundy/5 rounded-lg border border-burgundy/20" data-id="element-297">
              <p className="text-sm italic" data-id="element-298">
                "Before ChefChat, I'd stay up until midnight answering messages,
                only to miss the most important ones during the dinner rush."
              </p>
              <p className="text-sm font-semibold mt-2" data-id="element-299">
                — Mei Ling, Hawker Stall Owner
              </p>
            </div>
          </div>
          <div className="bg-cream rounded-lg p-6 shadow-lg" data-id="element-300">
            <div className="flex items-center mb-4" data-id="element-301">
              <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center text-success mr-4" data-id="element-302">
                <CheckIcon size={20} data-id="element-303" />
              </div>
              <h3 className="text-xl font-semibold text-charcoal" data-id="element-304">
                With ChefChat
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-305">
              <li className="flex items-start" data-id="element-306">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-success/10 flex items-center justify-center text-success mr-3 mt-0.5" data-id="element-307">
                  <CheckIcon size={14} data-id="element-308" />
                </div>
                <p data-id="element-309">
                  Instant responses to all customer inquiries, 24/7, in your
                  authentic voice
                </p>
              </li>
              <li className="flex items-start" data-id="element-310">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-success/10 flex items-center justify-center text-success mr-3 mt-0.5" data-id="element-311">
                  <CheckIcon size={14} data-id="element-312" />
                </div>
                <p data-id="element-313">
                  Automated reservation management that integrates with your
                  existing systems
                </p>
              </li>
              <li className="flex items-start" data-id="element-314">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-success/10 flex items-center justify-center text-success mr-3 mt-0.5" data-id="element-315">
                  <CheckIcon size={14} data-id="element-316" />
                </div>
                <p data-id="element-317">
                  Higher customer satisfaction and increased repeat business
                </p>
              </li>
              <li className="flex items-start" data-id="element-318">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-success/10 flex items-center justify-center text-success mr-3 mt-0.5" data-id="element-319">
                  <CheckIcon size={14} data-id="element-320" />
                </div>
                <p data-id="element-321">
                  Focus on your food and guests, not your phone and computer
                </p>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-success/5 rounded-lg border border-success/20" data-id="element-322">
              <p className="text-sm italic" data-id="element-323">
                "ChefChat handles 95% of our customer messages automatically. I
                only step in for the truly unique situations."
              </p>
              <p className="text-sm font-semibold mt-2" data-id="element-324">
                — Ahmad, Family Restaurant Owner
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-325">
          <div className="inline-flex items-center space-x-8 justify-center" data-id="element-326">
            <div className="text-center" data-id="element-327">
              <p className="text-3xl font-bold text-burgundy" data-id="element-328">87%</p>
              <p className="text-sm text-sage" data-id="element-329">Reduction in response time</p>
            </div>
            <div className="h-12 w-px bg-sage/30" data-id="element-330"></div>
            <div className="text-center" data-id="element-331">
              <p className="text-3xl font-bold text-burgundy" data-id="element-332">12+</p>
              <p className="text-sm text-sage" data-id="element-333">Hours saved weekly</p>
            </div>
            <div className="h-12 w-px bg-sage/30" data-id="element-334"></div>
            <div className="text-center" data-id="element-335">
              <p className="text-3xl font-bold text-burgundy" data-id="element-336">24/7</p>
              <p className="text-sm text-sage" data-id="element-337">Customer service</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ProblemStatement;